module.exports = __webpack_public_path__ + "./img/noimage.c9429caf78d2c3024acdc261b59cfee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noimage.jpg
// module id = ./src/assets/noimage.jpg
// module chunks = 0